export const iconFontAwesomeAccessibilityQuestion = (
	<i className="fa-solid fa-question"></i>
);
